import { render } from "./OrderDetailsSummary.vue?vue&type=template&id=521bf91a"
import script from "./OrderDetailsSummary.vue?vue&type=script&lang=js"
export * from "./OrderDetailsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__